
import {cardOrderExport, permissionList, purchaseCopeExport,getStoreVipCardList,getStoreVipClassList,giveOutVipCard} from "@/api/http";

const orderStatusNav: Array<{ name: string; id: number | string }> = [
    {
        name: "全部订单",
        id: "",
    },
    {
        name: "待付款",
        id: 0,
    },
    {
        name: "待核销",
        id: 1,
    },
    {
        name: "已完成",
        id: 2,
    },
    {
        name: "售后",
        id: 3,
    },
];

const columnList: Array<any> = [
    {
        prop: "ordersn",
        label: "订单编号",
        width: 164,
    },
    {
        prop: "create_time",
        label: "下单时间",
        width: 164,
    },
    {
        prop: "vip_card_title",
        label: "尊享卡名称",
        width: 100,
    },
    {
        prop: "price",
        label: "售价",
        width: 80,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 80,
    },
    {
        prop: "phone",
        label: "会员手机",
        width: 100,
    },
    {
        prop: "status_desc",
        label: "订单状态",
        width: 80,
    },
];

import { defineComponent, inject, ref, onMounted, reactive, watch } from "vue";
import { Throttle } from "@/api/api";
import { Request } from "@/api/request";
import { validateInput } from "@/assets/js/formRules";
import {ElLoading, ElMessageBox} from "element-plus";
export default defineComponent({
    name: "orderCard",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["购卡订单"]);
        const headClass = inject("headClass");
        let orderStatus = ref(0),
            loading = ref(false),
            dialog_show = ref(false),
            roleList = ref({} as any),
            tableData = ref([] as Array<any>),
            detailTable = ref([] as Array<any>),
            currentPage = ref(1),
            pageSize = ref(10),
            total = ref(0),
            screenParameter: any = ref({
              search: "",
              time: "",
              start_time: null,
              end_time: null,
            }),
            //门店尊享卡列表
            vipCardList = ref([
				{
					id:'0',
					title:'请选择尊享卡',
				}
			]),
            //门店尊享卡项目列表
            vipClassList = ref([]),
            form: any = ref({
              phone: "",
              vip_card_id: '0',
              start_time: '',
              start_time_text: '',
              end_time: '',
              end_time_text: '',
              vip_class_ids: '',
              surplus_numbers: '',
            }),
            dialogTitle = ref(""),
            dialogFormVisible = ref(false),
            orderDetail: any = ref({}),
            dialogNavIndex = ref(0),
            dialogWriteoffList = ref([] as Array<any>),
            dialogWriteoffId = ref(null),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入核销码", value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });

        let getTableData = () => {
                let mydata = {
                    type:1,
                    role_name:'order_card',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                let data: any = {
                    ...screenParameter.value,
                    page: currentPage.value,
                    pagesize: pageSize.value,
                    status: orderStatusNav[orderStatus.value].id,
                };
                delete data.time;
                Object.keys(data).forEach((key) => {
                    if (data[key] == null) {
                        delete data[key];
                    }
                });
                loading.value = true;
                Request.axiosInstance({
                    url: "adminapi/Order/purchaseCardOrderList",
                    data,
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
			addCard = () => {
				dialog_show.value = true
			},
			selectCard = (e:any) => {
				form.value.vip_card_id = e
				// 获取尊享卡项目列表
				getVipClass(form.value.vip_card_id);
			},
			selectStartTime = (e:any) => {
				form.value.start_time_text = e
				form.value.start_time = new Date(e).getTime() / 1000;
			},
			selectEndTime = (e:any) => {
				form.value.end_time_text = e
				form.value.end_time = new Date(e).getTime() / 1000;
			},
			// 获取门店所有尊享卡列表
            getVipCard = (): void => {
				getStoreVipCardList({}).then((res: any)=>{
					vipCardList.value = vipCardList.value.concat(res?.content?.list || []);
				})
			},
			// 获取门店所有尊享卡项目列表
            getVipClass = (vipCardId:number): void => {
				getStoreVipClassList({vip_card_id:vipCardId}).then((res: any)=>{
					vipClassList.value = res?.content?.list || [];
				})
			},
            // 编辑剩余次数
            surplusChange = (e: number,index:number): void => {
				if(e > (vipClassList.value as any)[index]['number']){
					(vipClassList.value as any)[index]['surplus_number'] = (vipClassList.value as any)[index]['number'];
				}else if(e < 0){
					(vipClassList.value as any)[index]['surplus_number'] = 0;
				}else{
					(vipClassList.value as any)[index]['surplus_number'] = e;
				}
            },
			// 切换每页数量大小
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
			// 切换分页
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            searchClick = ()=> {
              getTableData();
            },
			// 提交事件
            _formSubmit = new Throttle().use(()=> {
				let data = form.value;
				// 遍历获取对应的门店尊享卡项目id、剩余次数
                let vipClassIdList: any = [];
                let surplusNumberList: any = [];
				vipClassList.value.forEach((vipClass: any) => {
					vipClassIdList.push(vipClass.id);
					surplusNumberList.push(vipClass.surplus_number);
				});
				data['vip_class_ids'] = vipClassIdList.join(",");
				data['surplus_numbers'] = surplusNumberList.join(",");
				console.log(data)
				giveOutVipCard(data).then((res:any)=>{
                    if (res.status == 202) {
						dialog_show.value = false;
                        getTableData();
                    }
                });
            },3000),
            screenChange = (e: string): void => {
              console.log('e-------',e);
                if (e) {
                    screenParameter.value.start_time = e[0]
                        ? new Date(e[0]).getTime()/1000
                        : null;
                    screenParameter.value.end_time = e[1]
                        ? new Date(e[1]).getTime()/1000
                        : null;
                } else {
                  screenParameter.value.start_time = '';
                  screenParameter.value.end_time = '';
                }
                getTableData();
            },
            writeoff = () => {
                Request.axiosInstance({
                    url: "adminapi/Order/vipwriteoff",
                    data: {
                        order_id: orderDetail.value.id,
                        vip_class_id: dialogWriteoffId.value,
                    },
                }).then((res: any) => {
                    if (res.status == 202) {
                        orderDetail.value.nucleus_pin_code_status = 1;
                        getTableData();
                    }
                });
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
    
                cardOrderExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(()=>{
                    loading.close();
                });
            },
            columnChange = (item: any, type: number) => {
                switch (type) {
                    case 0:
                    case 1:
                        dialogFormVisible.value = true;
						let arr = [[
							'订单编号',
							item.ordersn,
							'下单时间',
							item.create_time,
							'尊享卡名称',
							item.vip_card_title,
							'售价',
							item.price,
						],[
							'会员号',
							item.user_id,
							'会员手机',
							item.phone,
							'订单状态',
							item.status_text,
						]];
                        orderDetail.value = item;
                        detailTable.value = arr;
                        dialogNavIndex.value = type;
                        Request.axiosInstance({
                            url: "adminapi/VipClass/getOrderVipClassList",
                            data: {
                                id: item.id,
                            },
                        }).then((res: any) => {
                            dialogWriteoffList.value = res?.content?.list || [];
                        });
                        break;
                    default:
                        let callBack = (status: number) => {
                            Request.axiosInstance({
                                url: "adminapi/Order/paragraph",
                                data: {
                                    order_id: item.id,
                                    status,
                                },
                            });
                        };
                        ElMessageBox.confirm(
                            type == 2
                                ? "如线下退款则点击标记退款，线上退款则点击确认退款"
                                : "是否拒绝退款？",
                            type == 2 ? "是否同意退款？" : "提示",
                            {
                                confirmButtonText:
                                    type == 2 ? "确认退款" : "确定",
                                cancelButtonText:
                                    type == 2 ? "标记已退款" : "取消",
                                type: "warning",
                                cancelButtonClass: "cancel-button-class",
                                confirmButtonClass: "confirm-button-class",
                                distinguishCancelAndClose:true
                            }
                        )
                            .then((action:any) => {
                                if(action == 'confirm'){
                                    callBack(type);
                                }
                                //console.log(action)
                            })
                            .catch((msg:any) => {
                                //console.log(msg)
                                //取消或者关闭走这里
                                if(msg == 'cancel'){
                                    if (type==2){
                                        //标记已退款
                                        callBack(1);
                                    }else {
                                        //拒绝退款的取消啥都不做
                                    }
                                }
                                // if (type == 2) {
                                //     callBack(1);
                                // }
                            });
                    // case 2:
                    //     // 退款接口未完成
                    //     break;
                }
            };

        onMounted(() => {
            getTableData();
			getVipCard();
        });
        watch(orderStatus, (newValue, oldValue) => {
            getTableData();
        });

        return {
            orderStatusNav,
            orderStatus,
            loading,
            tableData,
            addCard,
            selectCard,
            getVipCard,
            getVipClass,
            selectStartTime,
            selectEndTime,
            vipCardList,
			vipClassList,
			surplusChange,
            form,
            _formSubmit,
            dialog_show,
            detailTable,
            headClass,
            getTableData,
            currentPage,
            pageSize,
            columnList,
            total,
            handleSizeChange,
            handleCurrentChange,
            dialogTitle,
            dialogFormVisible,
            orderDetail,
            dialogNavIndex,
            dialogWriteoffList,
            dialogWriteoffId,
            rules,
            columnChange,
            screenChange,
            screenParameter,
            writeoff,
			searchClick,
            exportChange,
            roleList
        };
    },
});
